var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import S from 's-js';
import * as Surplus from "surplus";
import data from 'surplus-mixin-data';
import { Page } from "./Page";
import { RequestErrors } from './RequestErrors';
export { SettingsRoute };
const SettingsRoute = (app) => __awaiter(this, void 0, void 0, function* () {
    yield app.init;
    const user = app.user();
    const model = SettingsModel(app, user, u => app.location.change(`#/@${u.username}`));
    return () => <SettingsPage {...model}/>;
}), SettingsModel = (app, user, onUpdate) => {
    const image = S.data(user.image), username = S.data(user.username), bio = S.data(user.bio), email = S.data(user.email), password = S.data(''), request = S.data(null), update = () => __awaiter(this, void 0, void 0, function* () {
        const { user } = yield request(app.client.user.put({
            username: username(),
            image: image(),
            bio: bio(),
            email: email(),
            password: password() || undefined
        }));
        app.user(user);
        onUpdate(user);
    });
    return { app, image, username, bio, email, password, request, update };
}, SettingsPage = (model) => (<Page app={model.app} title="Settings - Conduit" section={2 /* Settings */}>
            <Settings {...model}/>
        </Page>), Settings = ({ image, email, bio, username, password, update, request }) => (<div class="settings-page">
            <div class="container page">
                <div class="row">
                    <div class="col-md-6 offset-md-3 col-xs-12">
                        <h1 class="text-xs-center">Your Settings</h1>

                        <RequestErrors request={request}/>

                        <form>
                            <fieldset>
                                <fieldset class="form-group">
                                    <input fn={data(image)} class="form-control" type="text" placeholder="URL of profile picture"/>
                                </fieldset>
                                <fieldset class="form-group">
                                    <input fn={data(username)} class="form-control form-control-lg" type="text" placeholder="Username"/>
                                </fieldset>
                                <fieldset class="form-group">
                                    <textarea fn={data(bio)} class="form-control form-control-lg" rows={8} placeholder="Short bio about you"/>
                                </fieldset>
                                <fieldset class="form-group">
                                    <input fn={data(email)} class="form-control form-control-lg" type="text" placeholder="Email"/>
                                </fieldset>
                                <fieldset class="form-group">
                                    <input fn={data(password)} class="form-control form-control-lg" type="password" placeholder="New Password"/>
                                </fieldset>
                                <button class="btn btn-lg btn-primary pull-xs-right" type="button" onClick={update}>
                                    Update Settings
                                </button>
                            </fieldset>
                        </form>

                        <hr />

                        <a class="btn btn-outline-danger" href="#/logout">
                            Or click here to logout.
                        </a>
                    </div>
                </div>
            </div>
        </div>);
